export const AND_SEPARATOR = ' AND ';
export const HIGHLIGHT_REGEX = /[\ue000\ue001]/g;
export const MAX_SERVER_SUGGESTION_OF_KIND = 3;
export const OR_SEPARATOR = ' OR ';
export const SPACE = ' ';
export const PARTICIPANT_QUERY_FORMAT_STRING = 'participants:({0})';
export const PARTICIPANT_DISPLAYNAME_QUERY_FORMAT_STRING = 'participants:("{0}")';
